<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <v-card>
          <v-dialog
            persistent
            v-model="dialogPayment"
            width="800"
            hegiht="auto"
          >
            <material-card color="green" title="Crash Course User Payment">
              <v-form ref="formPayment">
                <v-container py-0>
                  <v-layout wrap>
                    <v-flex class="md6">
                      <v-layout wrap>
                        <v-flex class="md4 pt-1"><h6>Coure Name</h6></v-flex>
                        <v-flex class="md8 pt-2 mt-1"
                          >: {{ this.userPayment.crash_course_name }}</v-flex
                        >
                      </v-layout>
                      <v-layout wrap>
                        <v-flex class="md4 pt-1"><h6>Student Name</h6></v-flex>
                        <v-flex class="md8 pt-2 mt-1"
                          >: {{ this.userPayment.user_name }}</v-flex
                        >
                      </v-layout>
                      <v-layout wrap>
                        <v-flex class="md4 pt-1"
                          ><h6>Student Mobile</h6></v-flex
                        >
                        <v-flex class="md8 pt-2 mt-1"
                          >: {{ this.userPayment.mobile_number }}</v-flex
                        >
                      </v-layout>
                      <v-layout wrap>
                        <v-flex class="md4 pt-1"><h6>Status</h6></v-flex>
                        <v-flex class="md8 mt-1"
                          ><v-select
                            :items="statusList"
                            item-text="name"
                            item-value="id"
                            class="pt-1"
                            v-model="userPayment.status"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex class="md6">
                      <v-layout wrap>
                        <v-flex class="md4 pt-1"
                          ><h6>Payment Method</h6></v-flex
                        >
                        <v-flex class="md8 pt-2 mt-1"
                          >: {{ this.userPayment.payment_method }}</v-flex
                        >
                      </v-layout>
                      <v-layout wrap>
                        <v-flex class="md4 pt-1"
                          ><h6>Transaction Id</h6></v-flex
                        >
                        <v-flex class="md8 pt-2 mt-1"
                          >: {{ this.userPayment.transaction_id }}</v-flex
                        >
                      </v-layout>
                      <v-layout wrap>
                        <v-flex class="md4 pt-1"><h6>Course Amount</h6></v-flex>
                        <v-flex class="md8 pt-2 mt-1"
                          >: {{ this.userPayment.course_amount }} BDT</v-flex
                        >
                      </v-layout>
                      <v-layout wrap>
                        <v-flex class="md4 pt-1"><h6>Paid Amount</h6></v-flex>
                        <v-flex class="md8 pt-2 mt-1"
                          >: {{ this.userPayment.paid_amount }} BDT</v-flex
                        >
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 text-xs-right>
                      <v-btn
                        class="mx-0 font-weight-light"
                        color="success"
                        @click="updatePayment()"
                        >Save</v-btn
                      >
                      <v-btn
                        class="mx-2 font-weight-light"
                        color="info"
                        @click="closeModal()"
                        >Close</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>

              <v-divider />
            </material-card>
          </v-dialog>

          <v-divider />

          <v-dialog
            persistent
            v-model="dialogMakePayment"
            width="800"
            hegiht="auto"
          >
            <material-card color="green" title="Crash Course Student Payment">
              <v-form ref="formMakePayment" v-model="valid">
                <v-container py-0>
                  <v-layout wrap>
                    <v-flex class="md12">
                      <v-layout wrap>
                        <v-flex class="md4 pt-3"><h6>Select Crash Course</h6></v-flex>
                        <v-flex class="md8 pt-2 mt-1">
                          <v-select
                            :items="crashCourseList"
                            label="Select Course"
                            item-text="name"
                            item-value="id"
                            v-model="makePayment.crash_course_id"
                            :rules="courseIDRules" 
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                        

                    <v-flex class="md12">
                      <v-layout wrap>
                        <v-flex class="md4 pt-3"
                          ><h6>Select Student</h6></v-flex
                        >
                        <v-flex class="md6 pt-2 mt-1">
                          <v-text-field
                            class="green-input search-input"
                            label="Search by mobile.."
                            color="green"
                            v-model="searchTermStudent"
                            
                          />
                        </v-flex>
                        <v-flex class="md2 pt-3">
                          <v-btn :disabled="!searchTermStudent"
                            class="mx-2 font-weight-light btn-sm"
                            color="info" small   
                             @click="searchStudent()"                      
                            >Search</v-btn
                          ></v-flex
                        >
                      </v-layout>
                      <p style="text-align:center" v-if="foundStudent">{{foundStudent.name}}</p>
                      <p style="text-align:center" v-if="!foundStudent.id && isSearchStudent">No Student found</p>
                    </v-flex>
                     <v-flex class="md12">                     
                       <v-layout wrap>
                        <v-flex class="md4 pt-3"><h6>Select Payment Method</h6></v-flex>
                        <v-flex class="md8 pt-2 mt-1">
                          <v-select
                            :items="pamentMethodList"
                            label="Select Payment Method"
                            item-text="name"
                            item-value="id"
                            v-model="makePayment.payment_method"
                             :rules="pamentMethodRules" 
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                     <v-flex class="md12">                     
                       <v-layout wrap>
                        <v-flex class="md4 pt-3"><h6>Transaction Id</h6></v-flex>
                        <v-flex class="md8 ">
                        <v-text-field type="text"  :rules="transactionIdRules"   v-model="makePayment.transaction_id"  class="mt-4" placeholder="Transaction id"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                     <v-flex class="md12">                     
                       <v-layout wrap>
                        <v-flex class="md4 pt-3"><h6>Amount</h6></v-flex>
                        <v-flex class="md8 ">
                        <v-text-field type="number" :rules="amountRules"  v-model="makePayment.paid_amount"  class="mt-4"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>                        
                   
                    <v-flex xs12 text-xs-right>
                      <v-btn class="mx-0 font-weight-light" color="success"
                       :disabled="disableButton"
                       @click="onMakePaymentSubmit()"
                        >Save</v-btn
                      >
                      <v-btn
                        class="mx-2 font-weight-light"
                        color="info"
                         :disabled="disableButton"
                        @click="closeModalMakePayment()"
                        >Close</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>

              <v-divider />
            </material-card>
          </v-dialog>
        </v-card>

        <v-layout wrap>
          <v-flex class="md6 pb-0">
            <v-text-field
              class="green-input search-input"
              label="Search by name, mobile, transaction id..."
              color="green"
              v-model="searchTerm"
              @keyup="getPaymentList"
          /></v-flex>
          <v-flex class="md6" style="text-align: right">
            <v-btn color="success" @click="openMakePaymentModal()" small
              >Make Payment</v-btn
            >
          </v-flex>
        </v-layout>

        <material-card color="green" title="Crash Corues Student Payments">
          <v-data-table :headers="headers" :items="crashCoursePaymentList">
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.crash_course_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.mobile_number }}</td>
              <td>{{ item.payment_method }}</td>
              <td>{{ item.paid_amount }} BDT</td>
              <td>{{ item.transaction_id }}</td>
              <td>{{ item.status }}</td>
              <td>
                <v-btn color="success" @click="editPayment(item)" small
                  >Edit</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </material-card>

        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div>{{ noticeMessage }}</div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Form from "@/views/Form";
export default {
  components: {
    Form,
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState("crashCoursePayment", [
      "crashCoursePaymentList",
      "crashCourseList",
    ]),
  },
  mounted() {
    this.getCrashCourseList();
    this.getPaymentList();
  },
  data() {
    return {
      valid: true,
      userPayment: {},
      makePayment: {},
      searchTermStudent: "",
      isSearchStudent :false,
      foundStudent: {},
      color: null,
      searchTerm: "",
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      dialogPayment: false,
      disableButton :false,
      dialogMakePayment: false,
      courseIDRules: [(v) => !!v || "Course is required."],
      pamentMethodRules: [(v) => !!v || "Payment Method is required."],
      transactionIdRules: [(v) => !!v || "Transaction Id is required."],
      amountRules: [(v) => !!v || "Amount is required."],
      pamentMethodList: [
        { id: "bKash", name: "bKash" },
        { id: "Rocket", name: "Rocket" }
      ],
      statusList: [
        { id: "Pending", name: "Pending" },
        { id: "Enrolled", name: "Enrolled" },
        { id: "Cancel", name: "Cancel" },
      ],
      headers: [
        {
          sortable: true,
          text: "Course Name",
          value: "course_anme",
        },
        {
          sortable: true,
          text: "Student Name",
          value: "student_anme",
        },
        {
          sortable: false,
          text: "Student Mobile",
          value: "mobile_number",
        },
        {
          sortable: false,
          text: "Payment Method",
          value: "payment_method",
        },
        {
          sortable: false,
          text: "Paid Amount",
          value: "paid_amount",
        },
        {
          sortable: false,
          text: "Transaction Id",
          value: "transaction_id",
        },
        {
          sortable: false,
          text: "Status",
          value: "status",
        },

        {
          sortable: false,
          text: "Action",
          value: "",
        },
      ],

      noticeMessage: "",
      valueObj: {},
    };
  },
  created() {},
  methods: {
    ...mapActions("crashCoursePayment", [
      "getCrashCourseList",
      "getUserPaymentList",
      "getStudent",
      "createStudentPayment",
      "updateUserPayment",
    ]),

    onMakePaymentSubmit() {
  
      if (this.$refs.formMakePayment.validate()) {
        
        let obj = {
            "user_id":this.foundStudent.id,
            "crash_course_id":this.makePayment.crash_course_id,
            "paid_amount" :this.makePayment.paid_amount,
            "payment_method":this.makePayment.payment_method,
            "transaction_id" :this.makePayment.transaction_id
        }
      
        this.disableButton = true;

        this.createStudentPayment(obj)
          .then((response) => {
            
            if (response.status == "OK") {
              this.closeModalMakePayment();
               this.$refs.formMakePayment.resetValidation();
              this.getPaymentList();
              this.disableButton = false;             
              this.color = "success";
              this.noticeMessage = response.messages;
              this.snack("top");
            } else {
              this.noticeMessage = response.messages;
              this.snack("top");
              this.disableButton = false;
            }
          })
          .catch((err) => {
            this.disableButton = false;
            console.log(err);
          });
      } else {
      }
    },

    getPaymentList() {
      let obj = {
        search_item: this.searchTerm,
      };
      const response = this.getUserPaymentList(obj);
    },

    searchStudent() {
      this.isSearchStudent = true;
      let obj = {
        search_item: this.searchTermStudent,
      };
      this.getStudent(obj).then((response) => {
        if (response) {
          this.foundStudent = response ;
          // this.closeModal();
          // this.color = "success";
          // this.noticeMessage = "Success! " + response.messages;
          // this.snack("top");
          // this.getPaymentList();
        } else {
          // this.color = "warning";
          // this.noticeMessage = "Warning! " + response.messages;
          // this.snack("top");
        }
      });
    },
   
   editPayment(item) {
      this.userPayment = item;
      this.dialogPayment = true;
    },
    openMakePaymentModal() {
      this.dialogMakePayment = true;
    },
    closeModalMakePayment() {
      this.isSearchStudent = false;
      this.dialogMakePayment = false;
      this.$refs.formMakePayment.reset();
      this.isSearchStudent = false;
      this.foundStudent = {};
      this.makePayment = {};
    },
    closeModal() {
      this.dialogPayment = false;
      //  this.$refs.formPayment.reset();
      this.userPayment = {};
    },
    updatePayment() {
      const obj = {
        id: this.userPayment.id,
        user_id: this.userPayment.user_id,
        crash_course_id: this.userPayment.crash_course_id,
        course_amount: this.userPayment.course_amount,
        paid_amount: this.userPayment.paid_amount,
        status: this.userPayment.status,
      };

      this.updateUserPayment(obj).then((response) => {
        if (response.status == "OK") {
          this.closeModal();
          this.color = "success";
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
          this.getPaymentList();
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
        }
      });
    },
    goDetailsPage(id) {
      this.$router.push("/daily-quiz-details/" + id);
    },
    getBackData(data) {
      this.color = data.status === "OK" ? "success" : "warning";
      if (data.status === "OK") {
        this.noticeMessage = "Success! " + data.messages;
        this.dialog = false;
      } else {
        this.noticeMessage = "Warning! " + data.messages;
      }
      this.snack("top");
    },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snackbar = true;
    },
  },
};
</script>
